"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const locale = {
  placeholder: 'Sila pilih masa'
};
var _default = exports.default = locale;